import type { Factory } from 'walden-fast/types/mocks';

export const factoryList = <Type>(
  length: number,
  factoryMethod: Factory<Type>,
  overrides?: Partial<Type>[],
): Type[] => {
  return Array.from({ length }).map((_value, index) =>
    factoryMethod(overrides?.[index]),
  );
};

export const selectRandom = <Item>(items: Item[]) => {
  return items[Math.floor(Math.random() * items.length)] as Item;
};
